import { useQuery } from 'react-query';
import axios from 'axios';
import { commonHeaders } from '../../constants/HeadersAPI';
import { BranchAPI } from '../../constants/API';

export type BranchItemDto = {
  id: number;
  code: string;
  name: string;
  isActive: boolean;
};

export const useGetBranches = () => {
  const { data: branches = [], isLoading } = useQuery<BranchItemDto[]>(
    ['branches', 'all'],
    () => axios.get(BranchAPI.getAll, commonHeaders()).then((r) => r.data)
  );
  // Системный "default" филиал не должен отображаться ни в каких селекторах.
  const DEFAULT_BRANCH = "default";
  const defaultLower = DEFAULT_BRANCH.toLowerCase();
  const activeBranches = branches.filter(
    (b) =>
      b.isActive !== false &&
      b.id !== 0 &&
      b.code.trim().toLowerCase() !== defaultLower &&
      b.name.trim().toLowerCase() !== defaultLower
  );
  return { branches: activeBranches, isLoading };
};

